export var version = {
  "@ant-design/pro-card": "2.0.2",
  "@ant-design/pro-components": "2.3.4",
  "@ant-design/pro-descriptions": "2.0.3",
  "@ant-design/pro-field": "2.0.3",
  "@ant-design/pro-form": "2.0.3",
  "@ant-design/pro-layout": "7.0.2",
  "@ant-design/pro-list": "2.0.3",
  "@ant-design/pro-provider": "2.0.2",
  "@ant-design/pro-skeleton": "2.0.2",
  "@ant-design/pro-table": "3.0.3",
  "@ant-design/pro-utils": "2.0.2"
};